export class LoadTfModulesData {
    static type = '[TFModules] LoadTfModulesData'
    constructor(){}
}

export class SetTfModulesFactorisationMode {
    static type = '[TFModules] SetTfModulesFactorisationMode'
    constructor(public payload: any){}
}

export class ClearTfModuleRepository {
    static type = '[TFModules] ClearTfModuleRepository'
    constructor(){}
}

export class SetTfModuleRepositoryByPath {
    static type = '[TFModules] SetTfModuleRepositoryByPath'
    constructor(public payload: any){}
}

export class SetTfModuleRepositoryByName {
    static type = '[TFModules] SetTfModuleRepositoryByName'
    constructor(public name: any) {}
}